import { render, staticRenderFns } from "./lazyblock_last_posts.vue?vue&type=template&id=7cd5725d&scoped=true"
import script from "./lazyblock_last_posts.vue?vue&type=script&lang=js"
export * from "./lazyblock_last_posts.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_last_posts.vue?vue&type=style&index=0&id=7cd5725d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd5725d",
  null
  
)

export default component.exports